import { CASES } from '../EnumTypes/ActionEnumTypes';
import { getClientCaseCounts as getClientCaseCountsConnector } from 'Connectors/CaseConnector';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
    type: CASES.GET_CLIENT_CASE_COUNTS_INIT,
});

const success = (casesCounts) => ({
    type: CASES.GET_CLIENT_CASE_COUNTS_SUCCESS,
    payload: {
        casesCounts,
    },
});

const failure = () => ({
    type: CASES.GET_CLIENT_CASE_COUNTS_FAILURE,
});

const getClientCaseCounts = (id) => async (dispatch) => {
    dispatch(init());
    try {
        dispatch(ViewManagementModule.Actions.showLoader());
        const { data } = await getClientCaseCountsConnector(id);
        dispatch(success(data));
        // dispatch(ViewManagementModule.Actions.hideLoader());
    } catch (err) {
        dispatch(ViewManagementModule.Actions.hideLoader());
        dispatch(failure());
    }
};

export default getClientCaseCounts;
